import React, { Component } from 'react';
import {connect} from 'react-redux'
import {Button,Modal,Form,FormGroup,FormControl,InputGroup} from 'react-bootstrap'
import FontAwsome from 'react-fontawesome'
import ReportStore from 'stores/ReportStore';
import Select from 'react-select'
import { Checkbox } from 'react-icheck'

class TaxinvoiceRVModal extends Component {

    constructor(props) {
        super(props)

        this.state = {doc:{},taxinvoice_lists:[],check_taxinvoice_lists:[],isCheckAll:false,searchBy:'bill_no',query:''}
    }

    componentDidMount() {

    }

    componentWillReceiveProps(newProps) {
        // if (newProps.show&&newProps.show!==this.props.show) {
        //     this.loadData()
        // }
    }

    loadData() {
		let {searchBy,query} = this.state
		let {genItemlist} = this.props
		ReportStore.loadTaxinvoiceList('all','543','','',searchBy,query,'0','0',(result)=>{
			let check_itemlist = []
            result.data.forEach((item,index)=>{
				let checkDup = -1
				checkDup = genItemlist.findIndex(x=>x.taxinvoice_no===item.bill_no)
				if (checkDup===-1) {
                    check_itemlist.push({isCheck:false,taxinvoice_no:item.bill_no})
                } else {
                    check_itemlist.push({isCheck:true,taxinvoice_no:item.bill_no})
                }
            })
            this.setState({doc:result.data.doc,taxinvoice_lists:result.data,check_taxinvoice_lists:check_itemlist})
        })    
    }

    getNumberFormat(value) {
        if(value===''||value===null||value===undefined||isNaN(value)){
          return ''
        }
        let _val = parseFloat(value)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }

	onSearchOptionChange(e) {
		this.setState({searchBy:e.value})
	}

	onTextChange(e) {
		this.setState({query:e.target.value})
	}

	onTextKeyPress(e) {
		if (e.charCode===13) {
			e.preventDefault()
			this.onSearchClick()
		}
	}

	onSearchClick() {
		this.loadData()
	}

	onTaxinvoiceChange(index) {
		let {check_taxinvoice_lists} = this.state
		if (check_taxinvoice_lists[index].isCheck)
			check_taxinvoice_lists[index].isCheck = false
		else
			check_taxinvoice_lists[index].isCheck = true
		
		let find = check_taxinvoice_lists.findIndex(x=>x.isCheck===false)
		let check = false
		if (find===-1)
			check = true

		this.setState({check_taxinvoice_lists:check_taxinvoice_lists,isCheckAll:check})
	}

	onTaxinvoiceAllChange() {
		let {isCheckAll,check_taxinvoice_lists} = this.state
		let new_list = []
		if (isCheckAll) {
			new_list = check_taxinvoice_lists.map((item,index)=>{
				item.isCheck = false
				return item
			})
			this.setState({isCheckAll:false})
		} else {
			new_list = check_taxinvoice_lists.map((item,index)=>{
				item.isCheck = true
				return item
			})
			this.setState({isCheckAll:true})
		}
		this.setState({check_taxinvoice_lists:new_list})
	}

	onTaxinvoiceSelect() {
		let {check_taxinvoice_lists,doc,taxinvoice_lists} = this.state
        let items = []
        taxinvoice_lists.forEach((item,index)=>{
            if (check_taxinvoice_lists[index].isCheck)
                items.push(item)
        })
		let datas = {itemlist:items}
		this.setState({isCheckAll:false})
        if (this.props.onItemsSelect!==undefined)
            this.props.onItemsSelect(datas)
	}

    onHide() {
        this.setState({isCheckAll:false})
        this.props.onHide()
    }

	renderStatus(row){
		let result = (<span></span>)
	
		if (row.work_status==='0') {
		  	result = (<span className="label label-default" data-value="0"><FontAwsome name='clock-o'/> เริ่มต้น</span>)
		}else if (row.work_status==='1') {
		  	result = (<span className="label label-warning" data-value="1"><FontAwsome name='wrench'/> อยู่ระหว่างซ่อม</span>)
		} else if (row.work_status==='2') {
		  	result = (<span className="label label-primary" data-value="2"><FontAwsome name='hourglass-start'/> รอส่งมอบรถ</span>)
		} else if (row.work_status==='3') {
		  	result = (<span className="label label-success" data-value="3"><FontAwsome name='thumbs-o-up'/> ปิดจบงาน</span>)
		} else if (row.work_status==='5') {
		  	result = (<span className="label label-purple" data-value="5"><FontAwsome name='bitcoin'/> ตั้งเบิก</span>)
		} else{
		  	result = (<span></span>)
		}
	
		if(row.doc_status!==undefined && row.doc_status*1===2){
		  	result = (<div>{result}<span  className="label label-success"><FontAwsome name='money'/> ชำระเงินแล้ว</span></div>)
		}
		if(row.doc_cancel!==undefined && row.doc_cancel*1===1){
		  	result = (<div>{result}<span  className="label label-danger"><FontAwsome name='trash'/> ยกเลิก</span></div>)
		}
	
		if(row.doc_cancel_remark!==undefined && row.doc_cancel_remark!==''){
		  	result = (<div>{result}<span  className="label label-danger"><FontAwsome name='trash'/> {row.doc_cancel_remark}</span></div>)
		}
	
		return result
	}

    renderTaxinvoiceRowData() {
		let {taxinvoice_lists,check_taxinvoice_lists} = this.state
		if (taxinvoice_lists.length===0) {
			return(<tr><td colSpan={12}>ไม่พบข้อมูล</td></tr>)
		} else {
			return(
				taxinvoice_lists.map((item,index)=>{
					return(
						<tr key={index}>
							<td className='text-center'>
								<Checkbox
                                    onChange={this.onTaxinvoiceChange.bind(this,index)}
                                    checked={check_taxinvoice_lists[index].isCheck}
                                    checkboxClass="icheckbox_square-blue"
                                    increaseArea="20%"
                                    label={''}
                                >
                                </Checkbox>
							</td>
							<td className='text-center'>{item.doc_date}</td>
							<td className='text-center'>{item.bill_no}</td>
							<td className='text-center'>{item.work_no}</td>
							<td className='text-center'>{item.car_registration_no}</td>
							<td className='text-center'>{item.brand}</td>
							<td className='text-center'>{item.model}</td>
							<td className='text-center'>{item.mileage}</td>
							<td className='text-left'>{item.customer_name}</td>
							<td className='text-right'>{this.getNumberFormat(item.amount)}</td>
							<td className='text-center'>{item.payment_date}</td>
							<td className='text-center'>{this.renderStatus(item)}</td>
						</tr>
					)
				})
			)
		}
	}

    renderTaxinvoiceTable() {
		let {isCheckAll} = this.state
		return(
			<div className='table-responsive'>
				<table className='table table-hover table-bordered-solid table-gen-doc' style={{marginBottom:'0'}}>
					<thead>
						<tr>
							<th style={{width:'50px'}} className='text-center'>
								<Checkbox
                                    onChange={this.onTaxinvoiceAllChange.bind(this)}
                                    checked={isCheckAll}
                                    checkboxClass="icheckbox_square-blue"
                                    increaseArea="20%"
                                    label={''}
                                >
                                </Checkbox>
							</th>
                            <th className='text-center' style={{width:'100px'}}>วันที่ออก</th>
                            <th className='text-center' style={{width:'120px'}}>ใบกำกับภาษี</th>
                            <th className='text-center' style={{width:'120px'}}>ใบงานเลขที่</th>
                            <th className='text-center' style={{width:'120px'}}>ทะเบียนรถ</th>
							<th className='text-center' style={{width:'100px'}}>ยี่ห้อ</th>
                            <th className='text-center' style={{width:'100px'}}>รุ่น</th>
                            <th className='text-center' style={{width:'100px'}}>กม.</th>
                            <th className='text-center' style={{width:'150px'}}>ชื่อลูกค้า</th>
                            <th className='text-center' style={{width:'120px'}}>มูลค่า(บาท)</th>
                            <th className='text-center' style={{width:'100px'}}>วันรับเงิน</th>
                            <th className='text-center' style={{width:'70px'}}>สถานะ</th>
						</tr>
					</thead>
					<tbody>
						{this.renderTaxinvoiceRowData()}
					</tbody>
				</table>
			</div>
		)
	}

	renderToolbar() {
        let {query} = this.state
        return(
            		<div style={{marginBottom:'5px'}}>
                		<Form inline>
							<FormGroup>
								<Select
									value={this.state.searchBy}
									options={[
										{
											label: 'เลขที่ใบกำกับภาษี',
											value: 'bill_no'
										},
										{
											label: 'ใบงานเลขที่',
											value: 'work_no'
										},
										{
											label: 'ทะเบียนรถ',
											value: 'car_registration_no'
										},
										{
											label: 'ลูกค้า/เจ้าของรถ',
											value: 'customer_name'
										},
										{
											label: 'บริษัทประกัน',
											value: 'insurance_name'
										}
									]}
									clearable={false}
									onChange={this.onSearchOptionChange.bind(this)}
									style={{width:'180px'}}
								/>
							</FormGroup>
							{' '}
							<FormGroup>
                                <InputGroup>
                                    <FormControl placeholder='ค้นหา' value={query} onChange={this.onTextChange.bind(this)} onKeyPress={this.onTextKeyPress.bind(this)} />
                                    <InputGroup.Addon className='btn' onClick={this.onSearchClick.bind(this)}><FontAwsome name='search'/></InputGroup.Addon>
                                </InputGroup>  
                            </FormGroup>
                        </Form>
            		</div>            
        )
    }

    render() {
        let {show} = this.props
        return(
            <Modal show={show} onHide={this.onHide.bind(this)} dialogClassName="midwidth-dialog">
                <Modal.Header closeButton>
                    <Modal.Title>เลือกรายการจากใบกำกับภาษี</Modal.Title>
                </Modal.Header>
                <Modal.Body>
					{this.renderToolbar()}
                    {this.renderTaxinvoiceTable()}
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle='primary' onClick={this.onTaxinvoiceSelect.bind(this)}><FontAwsome name='check' />&nbsp;เลือกรายการ</Button>
                    <Button onClick={this.onHide.bind(this)}><FontAwsome name='close' />&nbsp;ปิด</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}    

TaxinvoiceRVModal.defaultProps = {
	genItemlist:[]
}

export default TaxinvoiceRVModal = connect(
    (state) => ({messages: state.message.view.doc.GeneralDoc}),null,null,{withRef:true}
)(TaxinvoiceRVModal);    



// WEBPACK FOOTER //
// ./src/view/doc/TaxinvoiceRVModal.js